// Single source of UI copy for both locales. Shared verbatim with the mobile
// app (mobile/i18n/dictionary.js) - keep the two files identical.

export const LOCALES = ['hu', 'en'];
export const DEFAULT_LOCALE = 'hu';

export const INTL_LOCALE = {
  hu: 'hu-HU',
  en: 'en-GB'
};

const dictionary = {
  hu: {
    'app.name': 'EventHunter',
    'app.tagline': 'Mi történik a környékeden?',
    'app.taglineCity': '{city} programjai',
    'app.subtitle': '{count} program vár rád',

    'city.all': 'Összes város',
    'city.select': 'Város',
    'city.title': 'Válassz várost',

    'featured.title': 'Kiemelt program',
    'featured.badge': 'Kiemelt',

    'favourites.title': 'Kedvencek',
    'favourites.add': 'Kedvencekhez adás',
    'favourites.remove': 'Eltávolítás a kedvencekből',
    'favourites.count': '{count} mentett program',
    'favourites.empty.title': 'Még nincs mentett programod',
    'favourites.empty.body': 'Koppints a szívre bármelyik programnál, és itt találod meg.',
    'favourites.empty.browse': 'Programok böngészése',
    'favourites.unavailable': 'Már nem elérhető',
    'favourites.past': 'Elmúlt',
    'favourites.clearPast': 'Elmúltak törlése',

    'results.toTop': 'Vissza a tetejére',

    'search.placeholder': 'Program, helyszín vagy előadó',
    'search.submit': 'Keresés',
    'search.clear': 'Keresés törlése',

    'filters.open': 'Szűrők',
    'filters.title': 'Szűrők',
    'filters.apply': 'Mutasd a találatokat',
    'filters.applyCount': '{count} program mutatása',
    'filters.clear': 'Összes törlése',
    'filters.close': 'Bezárás',
    'filters.location': 'Helyszín',
    'filters.city': 'Város',
    'filters.country': 'Ország',
    'filters.venue': 'Helyszín neve',
    'filters.district': 'Kerület',
    'filters.date': 'Időpont',
    'filters.dateFrom': 'Ettől',
    'filters.dateTo': 'Eddig',
    'filters.price': 'Ár',
    'filters.freeOnly': 'Csak ingyenes',
    'filters.category': 'Kategória',
    'filters.genre': 'Műfaj',
    'filters.features': 'Extrák',
    'filters.music': 'Zene',
    'filters.active': 'Aktív szűrők',
    'filters.selectDate': 'Válassz dátumot',
    'filters.done': 'Kész',
    'filters.cancel': 'Mégse',

    'sort.label': 'Rendezés',
    'sort.title': 'Rendezés',
    'sort.date-asc': 'Legközelebbi elöl',
    'sort.date-desc': 'Legkésőbbi elöl',
    'sort.price-asc': 'Legolcsóbb elöl',
    'sort.price-desc': 'Legdrágább elöl',
    'sort.distance-asc': 'Legközelebbi hozzám',

    'quick.today': 'Ma',
    'quick.tomorrow': 'Holnap',
    'quick.weekend': 'Hétvégén',
    'quick.week': 'Egy héten belül',
    'quick.free': 'Ingyenes',
    'quick.all': 'Mind',

    'price.free': 'Ingyenes',
    'price.from': '{amount}-tól',
    'price.unknown': 'Ár nincs megadva',

    'tickets.available': 'Van jegy',
    'tickets.limited': 'Utolsó jegyek',
    'tickets.soldout': 'Elfogyott',

    'results.count': '{count} program',
    'results.countOne': '1 program',
    'results.none': '0 program',
    'results.loadMore': 'További programok',
    'results.loading': 'Betöltés…',
    'results.end': 'Ez volt az összes találat',

    'empty.title': 'Nincs találat',
    'empty.body': 'Próbálj tágabb időszakot vagy kevesebb szűrőt.',
    'empty.reset': 'Szűrők törlése',

    'error.title': 'Nem sikerült betölteni',
    'error.body': 'Ellenőrizd a kapcsolatot, és próbáld újra.',
    'error.retry': 'Újra',

    'detail.back': 'Vissza',
    'detail.when': 'Mikor',
    'detail.where': 'Hol',
    'detail.category': 'Kategória',
    'detail.genre': 'Műfaj',
    'detail.features': 'Extrák',
    'detail.price': 'Ár',
    'detail.about': 'A programról',
    'detail.tickets': 'Jegyvásárlás',
    'detail.noTicketUrl': 'Nincs online jegylink',
    'detail.otherDates': 'További időpontok',
    'detail.map': 'Megnyitás térképen',
    'detail.share': 'Megosztás',
    'detail.copied': 'Link a vágólapra másolva',
    'detail.notFound': 'Ez a program nem található',

    'cat.concert': 'Koncert',
    'cat.party': 'Party',
    'cat.festival': 'Fesztivál',
    'cat.stage': 'Színpad',
    'cat.family': 'Családi',
    'cat.exhibition': 'Kiállítás',
    'cat.dance': 'Tánc',
    'cat.learning': 'Tudás',
    'cat.sport': 'Sport',
    'cat.other': 'Egyéb',

    'music.popular': 'Könnyűzene',
    'music.classical': 'Komolyzene',
    'music.folk': 'Népzene',

    'district.label': '{district}. kerület',
    'distance.away': '{km} km',

    'location.denied': 'Engedélyezd a helymeghatározást a távolság szerinti rendezéshez.',
    'location.unavailable': 'A helyzeted nem elérhető. Próbáld újra.',
    'location.unsupported': 'Ez a böngésző nem támogatja a helymeghatározást.',

    'locale.switch': 'English',
    'locale.switchShort': 'EN',
    'locale.current': 'Magyar',

    'legal.menu': 'Információk',
    'legal.privacy': 'Adatvédelem',
    'legal.contact': 'Kapcsolat',
    'legal.coverage':
      'Jelenleg főként budapesti programokat mutatunk, de folyamatosan bővítjük más városok eseményeivel is.',
    'legal.sources': 'A programok adatai a helyszínek saját oldalairól származnak.'
  },

  en: {
    'app.name': 'EventHunter',
    'app.tagline': "What's on near you",
    'app.taglineCity': "What's on in {city}",
    'app.subtitle': '{count} events waiting for you',

    'city.all': 'All cities',
    'city.select': 'City',
    'city.title': 'Choose a city',

    'featured.title': 'Featured event',
    'featured.badge': 'Featured',

    'favourites.title': 'Favourites',
    'favourites.add': 'Add to favourites',
    'favourites.remove': 'Remove from favourites',
    'favourites.count': '{count} saved',
    'favourites.empty.title': 'Nothing saved yet',
    'favourites.empty.body': 'Tap the heart on any event and it will show up here.',
    'favourites.empty.browse': 'Browse events',
    'favourites.unavailable': 'No longer listed',
    'favourites.past': 'Past',
    'favourites.clearPast': 'Clear past events',

    'results.toTop': 'Back to top',

    'search.placeholder': 'Event, venue or artist',
    'search.submit': 'Search',
    'search.clear': 'Clear search',

    'filters.open': 'Filters',
    'filters.title': 'Filters',
    'filters.apply': 'Show results',
    'filters.applyCount': 'Show {count} events',
    'filters.clear': 'Clear all',
    'filters.close': 'Close',
    'filters.location': 'Location',
    'filters.city': 'City',
    'filters.country': 'Country',
    'filters.venue': 'Venue',
    'filters.district': 'District',
    'filters.date': 'When',
    'filters.dateFrom': 'From',
    'filters.dateTo': 'To',
    'filters.price': 'Price',
    'filters.freeOnly': 'Free only',
    'filters.category': 'Category',
    'filters.genre': 'Genre',
    'filters.features': 'Extras',
    'filters.music': 'Music',
    'filters.active': 'Active filters',
    'filters.selectDate': 'Pick a date',
    'filters.done': 'Done',
    'filters.cancel': 'Cancel',

    'sort.label': 'Sort',
    'sort.title': 'Sort by',
    'sort.date-asc': 'Soonest first',
    'sort.date-desc': 'Latest first',
    'sort.price-asc': 'Cheapest first',
    'sort.price-desc': 'Most expensive first',
    'sort.distance-asc': 'Nearest to me',

    'quick.today': 'Today',
    'quick.tomorrow': 'Tomorrow',
    'quick.weekend': 'This weekend',
    'quick.week': 'Next 7 days',
    'quick.free': 'Free',
    'quick.all': 'All',

    'price.free': 'Free',
    'price.from': 'from {amount}',
    'price.unknown': 'Price not listed',

    'tickets.available': 'Tickets available',
    'tickets.limited': 'Almost sold out',
    'tickets.soldout': 'Sold out',

    'results.count': '{count} events',
    'results.countOne': '1 event',
    'results.none': 'No events',
    'results.loadMore': 'Load more',
    'results.loading': 'Loading…',
    'results.end': "That's every match",

    'empty.title': 'No events found',
    'empty.body': 'Try a wider date range or fewer filters.',
    'empty.reset': 'Clear filters',

    'error.title': "Couldn't load events",
    'error.body': 'Check your connection and try again.',
    'error.retry': 'Retry',

    'detail.back': 'Back',
    'detail.when': 'When',
    'detail.where': 'Where',
    'detail.category': 'Category',
    'detail.genre': 'Genre',
    'detail.features': 'Extras',
    'detail.price': 'Price',
    'detail.about': 'About',
    'detail.tickets': 'Get tickets',
    'detail.noTicketUrl': 'No online ticket link',
    'detail.otherDates': 'More dates',
    'detail.map': 'Open in maps',
    'detail.share': 'Share',
    'detail.copied': 'Link copied to clipboard',
    'detail.notFound': 'This event could not be found',

    'cat.concert': 'Concerts',
    'cat.party': 'Parties',
    'cat.festival': 'Festivals',
    'cat.stage': 'Stage',
    'cat.family': 'Family',
    'cat.exhibition': 'Exhibitions',
    'cat.dance': 'Dance',
    'cat.learning': 'Talks',
    'cat.sport': 'Sport',
    'cat.other': 'Other',

    'music.popular': 'Popular music',
    'music.classical': 'Classical',
    'music.folk': 'Folk',

    'district.label': 'District {district}',
    'distance.away': '{km} km',

    'location.denied': 'Allow location access to sort events by distance.',
    'location.unavailable': 'Your location is unavailable. Please try again.',
    'location.unsupported': 'This browser does not support geolocation.',

    'locale.switch': 'Magyar',
    'locale.switchShort': 'HU',
    'locale.current': 'English',

    'legal.menu': 'Info',
    'legal.privacy': 'Privacy',
    'legal.contact': 'Contact',
    'legal.coverage':
      "For now our events are mostly in Budapest, but we're continuously adding events from other cities too.",
    'legal.sources': "Event details come from the venues' own websites."
  }
};

export function translate(locale, key, values) {
  const table = dictionary[locale] || dictionary[DEFAULT_LOCALE];
  const template = table[key] ?? dictionary[DEFAULT_LOCALE][key] ?? key;

  if (!values) {
    return template;
  }

  return template.replace(/\{(\w+)\}/g, (match, name) =>
    values[name] === undefined ? match : String(values[name])
  );
}

export default dictionary;
